import React, { useEffect, useState } from "react";
import styles from "./StoredCount.module.scss";
import { useSelector } from "react-redux";
import { getLoadingStatesState } from "@/entities/loadingStates";
import Loader from "../Loader/Loader";

interface StoredCountProps {
  onFocus: () => void;
}

const StoredCount: React.FC<StoredCountProps> = ({ onFocus }) => {
  const [storedCount, setStoredCount] = useState<number | null>(() => {
    const savedCount = localStorage.getItem("appDataCount");
    return savedCount ? Number(savedCount) : null;
  });
  const [extendedLoading, setExtendedLoading] = useState(false);

  useEffect(() => {
    const checkLocalStorage = () => {
      const currentCount = localStorage.getItem("appDataCount");
      const numericCount = currentCount ? Number(currentCount) : null;
      if (numericCount !== storedCount) {
        setStoredCount(numericCount);
        console.log("Count has changed:", numericCount);
      }
    };

    checkLocalStorage();
    const intervalId = setInterval(checkLocalStorage, 1000);

    return () => clearInterval(intervalId);
  }, [storedCount]);

  const { appReplayLoading } = useSelector(getLoadingStatesState);

  // Add extended loading effect
  useEffect(() => {
    if (appReplayLoading) {
      setExtendedLoading(true);
    } else {
      // Keep loading for 1 more second after appReplayLoading finishes
      const timeoutId = setTimeout(() => {
        setExtendedLoading(false);
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [appReplayLoading]);

  return (
    <p className={styles.descActive} onClick={onFocus}>
      See{" "}
      {extendedLoading || appReplayLoading ? (
        <Loader color="var(--dark-gray-1)" size={20} />
      ) : storedCount !== null ? (
        storedCount
      ) : (
        "No data available"
      )}{" "}
      apps
    </p>
  );
};

export default StoredCount;
